import { mapActions, mapState } from 'vuex'
import formButton from '@/components/common/form-button/form-button.vue'
import tagEdit from '@/components/pages/main-pages/settings/tags/tag-edit/tag-edit.vue'
import { cloneDeep } from 'lodash'

export default {
  components: {
    formButton
  },
  data() {
    return {
      columns: ['id', 'name', 'edit']
    }
  },
  computed: {
    ...mapState('tag', ['tags']),
    options: function () {
      return {
        filterable: false,
        headings: {
          edit: ' '
        },
        perPage: 10,
        orderBy: {
          column: 'name'
        },
        childRow: tagEdit
      }
    },
    transformedTags: function () {
      const transformedTags = cloneDeep(this.tags)
      transformedTags.forEach((tag) => {
        tag.edit = this.toggleEditRow
      })
      return transformedTags
    }
  },
  methods: {
    ...mapActions('tag', ['getTags']),
    toggleEditRow: function (id) {
      this.$refs.tags_table.toggleChildRow(id)
    }
  },
  async created() {
    if (this.tags.length === 0) {
      try {
        await this.getTags()
      } catch (e) {
        throw e.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/tags/tags-list/tags-list.js